// Shared styling for the Manage Parts screens
export const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: '40px',
        borderRadius: '8px',
        borderColor: state.isFocused ? '#FF5733' : '#d1d5db',
        boxShadow: state.isFocused ? '0 0 0 1px #FF5733' : 'none',
        fontSize: '14px',
        '&:hover': { borderColor: '#FF5733' }
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '14px',
        backgroundColor: state.isSelected ? '#FF5733' : state.isFocused ? '#fff1ec' : base.backgroundColor,
        color: state.isSelected ? '#fff' : base.color
    }),
    menuPortal: (base) => ({ ...base, zIndex: 70 })
};

// Portal menus to body so they are not clipped inside scrolling panels
export const selectPortalProps = {
    styles: selectStyles,
    menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
    menuPosition: 'fixed'
};

export const inputClass = 'w-full h-10 border border-gray-300 rounded-lg px-3 text-sm focus:outline-none focus:border-[#FF5733] focus:ring-1 focus:ring-[#FF5733] disabled:bg-gray-100 disabled:text-gray-500';
export const numberInputClass = `${inputClass} text-right`;
export const labelClass = 'block text-sm font-medium text-gray-700 mb-1';

export const isLowStock = (part) => {
    const min = Number(part.min_quantity || 0);
    return min > 0 && Number(part.quantity || 0) <= min;
};

export const isActiveStatus = (status) => (status || '').toUpperCase() === 'ACTIVE';

export const formatQty = (value) => {
    const num = Number(value || 0);
    return Number.isInteger(num) ? String(num) : num.toFixed(2);
};
